import { Link } from "react-router-dom";
import { ShieldCheck, Info } from "lucide-react";

/**
 * EEAT disclaimer used on top-100 pages. Explains our selection criteria for
 * platforms/anbieter and reinforces editorial independence.
 */
export const PlatformSelectionDisclaimer = () => {
  return (
    <section
      aria-labelledby="platform-disclaimer-heading"
      className="my-10 rounded-xl border border-border bg-muted/40 p-6"
    >
      <div className="flex items-start gap-3">
        <ShieldCheck className="h-6 w-6 text-primary shrink-0 mt-0.5" aria-hidden="true" />
        <div className="text-sm text-muted-foreground">
          <h2
            id="platform-disclaimer-heading"
            className="text-base font-semibold text-foreground mb-2"
          >
            Wie wir Plattformen und Anbieter auswählen
          </h2>
          <p className="mb-3">
            Unsere Redaktion arbeitet unabhängig und erhält keine Vergütung von den
            gelisteten Plattformen oder Anbietern. Jede Empfehlung basiert auf einer
            wiederholbaren Prüfung. Wir bewerten Portale und Makler nach den folgenden
            sechs Kriterien:
          </p>
          <ol className="list-decimal list-inside space-y-1.5 mb-3 text-foreground/90">
            <li>
              <strong>Verifizierbare Marktpräsenz</strong> in Deutschland (Impressum,
              aktive Listings der letzten 90 Tage, Handelsregistereintrag)
            </li>
            <li>
              <strong>Transparente Preis- und Objektangaben</strong> – Kaltmiete,
              Nebenkosten, Fläche und Nutzungsart sind vor Kontaktaufnahme sichtbar
            </li>
            <li>
              <strong>DSGVO-Konformität</strong> – vollständige Datenschutzerklärung
              und rechtssichere Datenverarbeitung
            </li>
            <li>
              <strong>Nutzerbewertungen und Sentiment</strong> aus mindestens drei
              öffentlichen Quellen (Trustpilot, Google, Branchenverzeichnisse)
            </li>
            <li>
              <strong>Aktualität der Listings</strong> – wir stichprobenartig prüfen,
              wie viele Angebote älter als 60 Tage sind
            </li>
            <li>
              <strong>Keine bezahlten Platzierungen</strong> in unserer Rangfolge –
              Reihenfolge und Bewertung sind redaktionell festgelegt
            </li>
          </ol>
          <p className="flex items-start gap-2 text-xs italic">
            <Info className="h-4 w-4 text-muted-foreground shrink-0 mt-0.5" aria-hidden="true" />
            <span>
              Zuletzt geprüft: April 2026 · Redaktionell verantwortlich:{" "}
              <Link to="/ueber-uns" className="text-primary hover:underline">
                Loie Favre, IHK-zertifizierte Immobilienberaterin
              </Link>
              . Details zu unseren Datenquellen findest du auf unserer{" "}
              <Link to="/ueber-uns" className="text-primary hover:underline">
                Über-uns-Seite
              </Link>
              .
            </span>
          </p>
        </div>
      </div>
    </section>
  );
};
